// Fetch About Us Page details
const aboutUsEndpoint = "content_aboutus.php?qsid=2";
export const getAboutUsPageContent = () => (dispatch, getState, Api) => {
  // FLAG-GETURL
  return Api.get(aboutUsEndpoint).then((response) => {
    return response;
  });
};
